// Imports
import React from 'react';
import styled from 'styled-components/macro';
import { setSaturation, setLightness } from 'polished';
import theme from '../../../../theme';


// Styled components
interface WrapperProps {
	paddingBottom?: string;
}

const Wrapper = styled.div<WrapperProps>`
	overflow: auto;
	overflow-y: hidden;
	max-width: 100%;
	${(props) => (props.paddingBottom ? `padding-bottom: ${props.paddingBottom};` : '')}
	
	&:first-child {
		th {
			padding-top: 0;
		}
	}
	
	&:not(:last-child) {
		margin-bottom: 1.5rem;
	}
`;

const Container = styled.table`
	width: 100%;
	background-color: #fff;
	border-collapse: collapse;
	border-spacing: 0;
	
	tr {
		&:nth-child(odd) {
			background-color: #fff;
		}
		
		&:nth-child(2n) {
			background-color: ${setSaturation(0.07, setLightness(0.98, theme.colors.background))};
		}
		
		&:last-child td {
			border-bottom-width: 0;
		}
		
		th,
		td {
			white-space: nowrap;
			text-align: left;
			padding: 0.5em 0.75em;
			border: solid #dbdbdb;
			
			&.allow-wrapping {
				overflow-wrap: break-word;
				width: auto;
				max-width: 75vw;
				white-space: normal;
			}
		}
		
		th {
			padding-top: 0.5em;
			padding-bottom: 0.75em;
			border-width: 0 0 2px;
			color: #363636;
			line-height: 1;
		}
		
		td {
			border-width: 0 0 1px;
			line-height: 1.3;
			vertical-align: middle;
			
			small {
				display: block;
			}
			
			form {
				display: inline-block;
				
				div.field {
					margin-top: 0;
					display: block;
					
					&:not(:last-child) {
						margin-bottom: 0.5rem;
					}
				}
			}
		}
	}
`;


// Define the accepted props
interface Props extends React.PropsWithChildren {
	paddingBottom?: string;
}


// Function component
const Table: React.FC<Props> = ({ paddingBottom, children }) => {
	return (
		<Wrapper paddingBottom={paddingBottom}>
			<Container>{children}</Container>
		</Wrapper>
	);
};

export default Table;
